import dayjs from "@helpers/dayjs";
import { FiltersType } from "../types";

const mappedDateKeys: Record<string, string> = {
  loading_ddt_created: "loading__ddt_created_at",
  loading_created_at: "loading__created_at",
};

const mappedMultiFilters: Record<string, string> = {
  delivery_status: "delivery_status__in",
  customer: "customer__id__in",
  importer: "importer__id__in",
  supplier: "supplier__id__in",
  producer: "producer__id__in",
  producer_mill: "producer_mill__id__in",
  production_method: "production_method__id__in",
  truck_supplier: "truck_supplier__id__in",
  warehousing: "target_warehouse_id__in",
  truck_kind: "truck_kind__macro_category__in",
  loading_ddt: "loading__ddt_number__in",
  terminal: "terminal__id__in",
  deposit_reference: "deposit_reference__in",
  pile: "pile__in",
  row: "rows__in",
  tiers: "tiers__in",
  depot: "depot__in",
  note: "unloading_comment__in",
  claims: "claims__in",
  marks: "loading__mark__in",
  sender: "depositor__id__in",
  consignee: "consignee__id__in",
  destination: "destination__id__in",
  delivery_info: "delivery_info__label__in",
  transport_reason: "loading__transport_reason__in",
  fcr: "fcr__fcr_number__in",
  fcr_status: "latest_fcr__release_date__isnull",
  hs_code: "hs_code__in",
  caad: "caad_code__in",
  bill_of_lading: "bill_of_lading__mbl_number__in",
  vessel: "ocean_vessel__id__in",
  commodities: "commodity__id__in",
  id_number: "id_number__in",
  thickness: "thickness__in",
  width: "width__in",
  length: "length__in",
  net_weight: "net_weight__in",
  gross_weight: "gross_weight__in",
  grade: "grade__in",
  heat: "heat__in",
  pieces: "pieces__in",
  comment_1: "comment_1__in",
  comment_2: "comment_2__in",
  ddt_customer_reference: "ddt_customer_reference_number__in",
  customer_reference: "bl_commodity__customer_reference_number__in",
  container: "bl_container__number__in",
  transport_contactor_customer: "tc_customer__id__in",
  transport_contactor: "delivery__transport_contactor__in",
  shipping_case__label: "shipping_case__id__in",
};

function normalizeParams(filterList: FiltersType) {
  const cleanedFilters = Object.fromEntries(
    Object.entries(filterList)
      .filter(([_, v]) => {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== "";
      })
      .map(([key, value]) => [
        key,
        Array.isArray(value)
          ? value.map((item: any) =>
              item && typeof item === "object" && "id" in item ? item.id : item,
            )
          : value,
      ]),
  );

  const transformedFilters: Record<string, any> = {};

  Object.entries(cleanedFilters).forEach(([key, value]) => {
    if (mappedMultiFilters[key]) {
      let transformedValue;
      if (Array.isArray(value)) {
        transformedValue = value.join(",");
      } else if (
        typeof value === "object" &&
        value !== null &&
        "label" in value
      ) {
        transformedValue = value.label;
      } else {
        transformedValue = value;
      }

      transformedFilters[mappedMultiFilters[key]] = transformedValue;
    } else if (mappedDateKeys[key]) {
      if (Array.isArray(value)) {
        const [gte, lte] = value;
        const mappedKey =
          mappedDateKeys[key.toLowerCase()] ?? key.toLowerCase();
        if (gte)
          transformedFilters[`${mappedKey}__gte`] = dayjs(gte)
            .startOf("day")
            .format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
        if (lte)
          transformedFilters[`${mappedKey}__lte`] = dayjs(lte)
            .endOf("day")
            .format("YYYY-MM-DDTHH:mm:ss.SSSSSS");
      }
    } else {
      transformedFilters[key] = value;
    }
  });

  return transformedFilters;
}

export default normalizeParams;
